// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1721205368512
      var cssReload = require("/Users/adrian/Documents/StarWay/eleek/static/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  